'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconYoutube(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M14.25 2.828c.69.181 1.232.713 1.415 1.39C16 5.442 16 8 16 8s0 2.557-.335 3.783a1.987 1.987 0 0 1-1.414 1.389C13.004 13.5 8 13.5 8 13.5s-5.003 0-6.25-.328a1.987 1.987 0 0 1-1.415-1.39C0 10.558 0 8 0 8s0-2.557.335-3.783a1.987 1.987 0 0 1 1.414-1.389C2.996 2.5 8 2.5 8 2.5s5.004 0 6.25.328ZM10.547 8 6.364 5.678v4.644L10.546 8Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M20.595 4.673a2.772 2.772 0 0 1 1.945 1.968C23 8.378 23 12 23 12s0 3.623-.46 5.359a2.772 2.772 0 0 1-1.945 1.968c-1.715.465-8.595.465-8.595.465s-6.879 0-8.595-.465a2.772 2.772 0 0 1-1.945-1.968C1 15.622 1 12 1 12s0-3.622.46-5.359a2.772 2.772 0 0 1 1.945-1.968C5.12 4.208 12 4.208 12 4.208s6.88 0 8.595.465ZM15.5 12 9.75 8.711v6.578L15.5 12Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconYoutube is deprecated and will be archived soon. Use IconYoutube instead.
 */
export function Experimental__IconYoutube(props) {
  return /*#__PURE__*/React.createElement(IconYoutube, props);
}